import React, { useEffect, useRef, useState } from 'react'
import { Table } from 'rsuite'
import LoaderComponent from '../CommonComponents/LoaderComponent'
import { FiLink } from 'react-icons/fi'
import { BiEdit, BiUnlink } from 'react-icons/bi'
import ModalComponent from '../CommonComponents/Modal'
import CreateContact from './createContact'
import { MdDeleteSweep } from 'react-icons/md'
const { Column, HeaderCell, Cell } = Table

export const LinkColumn = ({ rowData, supplierId, onEditClick, ...props }) => {
    return (
        <Cell {...props} className="table-link fw-bold">
            <div className='d-flex gap-3 align-items-center'>
                <div>
                    <BiEdit color='#104569' onClick={(e) => { onEditClick(e, rowData?.id) }} size={30} />
                </div>
                <div>
                    {(rowData?.supplierIds && rowData?.supplierIds?.includes(supplierId)) || (rowData?.supplierId && rowData?.supplierId === supplierId) ? (
                        <FiLink className='ms-auto' color="#198754" size={20} onClick={(e) => { e.stopPropagation() }} />
                    ) : (
                        <BiUnlink className='ms-auto' color="#FF0000" size={20} onClick={(e) => { e.stopPropagation() }} />
                    )}
                </div>
            </div>
        </Cell>
    )
}

const AllContacts = ({ extraClass = '', contacts = [], onClose, onCreateContact, supplierId = null, isLoading = false, onContactClick, onGetContactsData, field }) => {
    const columns = [
        {
            name: 'contactName',
            label: 'Name',
            width: 120
        },
        {
            name: 'email',
            label: 'Email',
            width: 160
        },
        {
            name: 'phone',
            label: 'Phone',
            width: 150
        }
    ]

    const divRef = useRef(null);
    const [tableData, setTableData] = useState([])
    const [isLoadingContacts, setIsLoadingContacts] = useState(false)
    const [contactId, setContactId] = useState(null)
    const [showEditModal, setShowEditModal] = useState(false)
    const [isRelaodContacts, setIsRelaodContacts] = useState(false)
    const [isDeletedContacts, setIsDeletedContacts] = useState(false)
    const [showDeletedContacts, setShowDeletedContacts] = useState(false)

    useEffect(() => {
        if (contacts && contacts?.length > 0) {
            const isDeletedContacts = contacts?.filter(data => !data?.status)
            setTableData(contacts?.filter(data => data?.status))
            if (isDeletedContacts && isDeletedContacts?.length > 0) {
                setIsDeletedContacts(true)
            } else {
                setIsDeletedContacts(false)
            }
        } else {
            setTableData([])
            setIsDeletedContacts(false)
        }
    }, [contacts])

    useEffect(() => {
        setIsLoadingContacts(isLoading)
    }, [isLoading])

    const headerElements = columns.map((col) => {
        return (
            <Column
                resizable
                key={col.name}
                width={col.width}
            >
                <HeaderCell title={col.label} className='fw-bold text-black fs-3 mb-0'>{col.label}</HeaderCell>
                <Cell dataKey={col.name} >
                    {rowData => {
                        return <p className='fw-normal text-black' title={rowData[col.name]}>{rowData[col.name]}</p>
                    }}
                </Cell>
            </Column>
        )
    })

    const handleEditClick = (e, contactId = null) => {
        e.stopPropagation()
        setContactId(contactId)
        setShowEditModal(true)
    }

    const onCloseEditModal = () => {
        setContactId(null)
        setShowEditModal(false)
        if (isRelaodContacts) {
            onGetContactsData(null, isRelaodContacts)
            setIsRelaodContacts(false)
        }
    }

    const handleIsRelaodContacts = () => {
        setIsRelaodContacts(true)
    }

    const handleClickOutside = (event) => {
        if (divRef.current && !divRef.current.contains(event.target) && !showEditModal) {
            onClose()
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showEditModal]);

    const handleShowDeletedContacts = () => {
        if (!showDeletedContacts) {
            contacts.sort((a, b) => {
                return b.status - a.status;
            })
            setTableData(contacts)
        } else {
            setTableData(contacts?.filter(data => data?.status))
        }
        setShowDeletedContacts(!showDeletedContacts)
    }

    const getRowClassName = (rowData) => {
        return rowData && rowData?.hasOwnProperty('status') ? (rowData?.status ? '' : 'deleted-contact') : '';
    }

    const handleOnContactClick = (rowData) => {
        if (rowData?.status) {
            onContactClick(rowData, field)
        }
    }

    return (
        <div ref={divRef} className={`all-contacts-view position-absolute top-100 bg-white shadow-lg rounded p-4 mt-1 ${extraClass}`} style={{ zIndex: 100 }}>
            <button className='existing-master-close text-black float-end mb-2' onClick={onClose}></button>
            <div className='header d-flex justify-content-between align-items-center border border-top-0 border-start-0 border-end-0 pb-2 clear-both'>
                <h3 className='text-blue fw-bold'>Contacts</h3>
                <MdDeleteSweep className={`ms-auto me-2`} color={!isDeletedContacts ? '#D9D9D9' : (!showDeletedContacts ? '#104569' : '#198754')} size={30} onClick={() => { isDeletedContacts && handleShowDeletedContacts() }} />
                <button
                    type="button"
                    className="fs-4 text-white rounded ps-3 pe-3 py-2 bg-dark-blue"
                    onClick={onCreateContact}
                    disabled={isLoadingContacts}
                >
                    Add New Contact
                </button>
            </div>
            <div className={`position-relative${isLoadingContacts ? ' loading' : ''}`}>
                {isLoadingContacts && <LoaderComponent />}
                <Table
                    width={500}
                    virtualized
                    height={400}
                    affixHeader={true}
                    data={tableData}
                    onRowClick={handleOnContactClick}
                    rowClassName={getRowClassName}
                >
                    {headerElements}
                    <Column
                        key='action'
                        width={70}
                        fixed="right"
                        dataKey='linkToVendor'
                    >
                        <HeaderCell>Action</HeaderCell>
                        <LinkColumn supplierId={supplierId} onEditClick={(e, id) => { handleEditClick(e, id) }} />
                    </Column>
                </Table>
            </div>
            {showEditModal && (
                <>
                    <ModalComponent size='xl' modalTitle='' open={showEditModal} handleClose={onCloseEditModal} dialogClassName='px-5 edit-new-contact-modal-dialog'>
                        <CreateContact onClose={onCloseEditModal} contactId={contactId} isEdit={true} setIsRelaodContacts={handleIsRelaodContacts} />
                    </ModalComponent>
                </>
            )}
        </div>
    )
}

export default AllContacts